import React, { useState, useRef } from "react";
import contentData from "../content.json";
import { Fade } from "react-awesome-reveal";
import { FaChevronDown } from "react-icons/fa";

/* ==========================================
*   JSON Template Example
*  ==========================================

  "academics": {
    "section": {
      "enable_section": true,
      "title": "~/Education",
      "navbar_name": "/Academics",
      "description": "Courses that I have completed or am on track to complete. Current GPA: 3.24"
    },

    * "enable_section": <true or false> to enable/disable section
    * "title": "Is what is displayed on the h3 tag to distinguish the section"
    * "navbar_name": "Is what is displayed on the navbar"
    * "description": "subtitle below the title element to distinguish the section"

    "general": {
      "school": "St. Mary's University",
      "degree": "Bachelor of Science in Computer Science",
      "start_year": 2021,
      "end_year": 2025
    },

    * "school": "The name of your school/university"
    * "degree": "Name of the degree your obtaining"
    * "start_year": "School start year"
    * "end_year": "school end year"

    "years": [
      {
        "year": 2021,
        "semester": "Fall",
        "courses": [
          {
            "abbreviation": "CS 1310",
            "name": "C Programming I",
            "credits": 3.0
          },
          {
            "abbreviation": "MT 1411",
            "name": "Pre Calculus",
            "credits": 4.0
          },
          {
            "abbreviation": "EN 1311",
            "name": "Rhetoric and Composition",
            "credits": 3.0
          },
          {
            "abbreviation": "PL 1301",
            "name": "Introduction to Philosophy",
            "credits": 3.0
          }
        ]
      },

    * "years": [{semester 1}, {semester 2}, ...]
    * "year": "Year of that semester"
    * "semester": "Name of the semester Fall/Spring/Summer"
    * "courses": [{course 1}, {course 2}, ...]
    * Each course has a course prefix/abreviation, full name, and credits

*/

const Education = () => {
  const education = contentData.academics;
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const totalCreditsPerYear = education.years.map((year) => {
    return parseFloat(
      year.courses.reduce((total, course) => {
        return total + course.credits;
      }, 0)
    );
  });

  return (
    <section id="education">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <button
              className="education-header"
              onClick={() => setIsOpen((prev) => !prev)}
              aria-expanded={isOpen}
              style={{
                display: "flex",
                alignItems: "center",
                background: "none",
                border: "none",
                color: "#7fffa7",
                fontSize: "2.5rem",
                fontFamily: "Fira Mono, monospace",
                cursor: "pointer",
                padding: 0,
                marginBottom: "1rem"
              }}
            >
              <span className="education-title">{education.section.title}</span>
              <FaChevronDown
                className={`dropdown-arrow${isOpen ? " open" : ""}`}
                style={{
                  marginLeft: "1rem",
                  transition: "transform 0.3s",
                  fontSize: "1.5rem",
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)"
                }}
              />
            </button>
            <div className="subtitle-a" style={{marginBottom: isOpen ? "1.5rem" : 0}}>{education.section.description}</div>
          </div>
        </div>
        <div
          className="education-content"
          ref={contentRef}
          style={{
            overflow: "hidden",
            transition: "max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
            maxHeight: isOpen ? `${contentRef.current?.scrollHeight || 1000}px` : 0
          }}
        >
          <div className="row">
            <div className="col-sm-12">
              <div className="row">
                {education.years.map((year, index) => (
                  <div className="col-md-6" key={index}>
                    <Fade
                      delay={index * 200}
                      cascade={false}
                      triggerOnce={true}
                    >
                      <div className="education">
                        <table>
                          <thead>
                            <tr>
                              <th>
                                {year.semester} {year.year} Courses
                              </th>
                              <th>
                                Total Credits: {totalCreditsPerYear[index].toFixed(1)}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {year.courses.map((course, idx) => (
                              <tr key={idx}>
                                <td data-tooltip={course.abbreviation}>{course.name}</td>
                                <td>{course.credits.toFixed(1)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </Fade>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
